@use "styles" as *;

$block: me-chips;

.#{$block} {
  display: flex;
  gap: space(4);

  &__body {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: inherit;
  }

  &--mobile {
    position: relative;
    overflow: hidden;

    @include fade-right($me-chips-fade-width);

    .#{$block}__body {
      flex-wrap: nowrap;
      scrollbar-width: none;
      overflow-x: scroll;
      flex-direction: row;
      padding-right: space($me-chips-fade-width);

      &::-webkit-scrollbar {
        display: none;
      }

      & > * {
        flex-shrink: 0;
        flex-grow: 1;
      }
    }
  }
}
